import { html } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function MountingPage(): Node {
  return html`
    <div>
      <h1>Mounting (mount)</h1>
      <p>Attach a component tree to the DOM.</p>

      <h2>Usage</h2>
      ${CodeBlock(`import { mount, html } from 'onefold';

const app = html\`<div>Hello, World</div>\`;
mount(app, document.getElementById('app')!);`)}

      <p><code>mount</code> clears the container's content and appends the node. This is the one place in your app where you connect onefold to the page.</p>

      <h2>With a Component Function</h2>
      ${CodeBlock(`function App(): Node {
  return html\`<div>My Application</div>\`;
}

mount(App(), document.getElementById('app')!);`)}

      ${Callout('mount() replaces the container content. If you need to append instead, use container.appendChild(node) directly with the result of html`...`.')}

      <h2>API</h2>
      <table>
        <tr><th>Function</th><th>Description</th></tr>
        <tr><td><code>mount(node, container)</code></td><td>Clear container and append node. The single "render" call.</td></tr>
      </table>

      <h2>raw() — Explicit HTML Insertion</h2>
      <p>If you need to insert actual HTML markup (not text), use <code>raw()</code>:</p>
      ${CodeBlock(`import { raw } from 'onefold';

// Only for trusted, developer-authored HTML — never user input
html\`<div>\${raw('<strong>Bold text</strong>')}</div>\``)}

      ${Callout('raw() runs a minimal sanitizer (strips scripts, event handlers, unsafe URLs). For user-generated HTML, pipe through DOMPurify first.', 'warn')}
    </div>
  `;
}
